import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { CTAButton } from './CTAButton';
const faqs = [{
  q: '¿Cómo accedo a MOVÉ SUAVE™ después de comprar?',
  a: 'Recibís acceso inmediato por email apenas confirmás tu compra. Podés entrar desde el teléfono, tablet o computadora — cuando quieras, donde quieras. No hay envíos, no hay esperas.'
}, {
  q: '¿Sirve si nunca me moví o si tengo muy poca energía?',
  a: "Sí, especialmente para vos. MOVÉ SUAVE™ está diseñado para cuerpos reales y días reales. Incluso podés hacer las rutinas de 3 minutos desde la cama si es lo único que tu energía te permite hoy. Acá no hay 'fallar'."
}, {
  q: '¿Hay cuota mensual o pagos recurrentes?',
  a: 'No. Es un único pago de por vida. Sin suscripciones, sin letra chica, sin cargos sorpresa. Pagás una vez y tenés acceso para siempre.'
}, {
  q: '¿Y si tengo un día malo y no puedo hacer nada?',
  a: 'Para eso existe el bono Días Difíciles™. Es un sistema anti-abandono pensado exactamente para esos momentos donde no tenés ganas ni energía. La idea es que NUNCA abandones — solo elegís la versión más suave.'
}, {
  q: '¿Cuánto tiempo necesito por día?',
  a: 'Desde 3 minutos. En serio. Hay rutinas de 3, 5 y 10 minutos. La constancia suave vale más que el esfuerzo extremo de un solo día.'
}, {
  q: '¿Cómo funciona la garantía de 60 días?',
  a: 'Tenés 60 días completos para probar todo el sistema. Si por cualquier motivo no sentís tu cuerpo más liviano, flexible y conectado — me escribís un email y te devuelvo el 100% de tu dinero. Sin preguntas, sin trámites.'
}, {
  q: '¿Para qué edades está pensado?',
  a: 'Para cualquier persona adulta que quiera volver a sentirse bien en su cuerpo, sin presión ni exigencia extrema. Tenemos personas desde 25 hasta 70+ años moviéndose suave.'
}, {
  q: '¿Necesito algún elemento o equipo especial?',
  a: 'No necesitás nada. Solo tu cuerpo y un espacio mínimo (incluso tu cama sirve). Todo está pensado para que sea simple y accesible.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full px-5 md:px-8 py-20 md:py-32 bg-base" data-id="element-72">
      <div className="max-w-2xl mx-auto" data-id="element-73">
        <div className="text-center mb-16 md:mb-20" data-id="element-74">
          <span className="text-[11px] md:text-xs font-semibold tracking-[0.2em] uppercase text-primary mb-6 block" data-id="element-75">
            Preguntas Frecuentes
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-ink leading-[1.1] tracking-tight" data-id="element-76">
            Todo lo que necesitás saber antes de empezar
          </h2>
        </div>

        <div className="flex flex-col gap-4 mb-20" data-id="element-77">
          {faqs.map((faq, i) => <div key={i} className="bg-secondary/40 rounded-2xl overflow-hidden border border-ink/5 transition-colors hover:bg-secondary/60" data-id="element-78">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-6 md:px-8 md:py-8 flex items-center justify-between gap-6 text-left" aria-expanded={openIndex === i} data-id="element-79">
                <span className="font-serif text-xl md:text-2xl text-ink leading-[1.2] tracking-tight" data-id="element-80">
                  {faq.q}
                </span>
                <span className="shrink-0 text-primary" data-id="element-81">
                  {openIndex === i ? <Minus className="w-6 h-6" data-id="element-82" /> : <Plus className="w-6 h-6" data-id="element-83" />}
                </span>
              </button>
              <AnimatePresence initial={false} data-id="element-84">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} className="overflow-hidden" data-id="element-85">
                    <p className="px-6 pb-6 md:px-8 md:pb-8 text-[17px] md:text-lg text-ink/80 leading-[1.75]" data-id="element-86">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="text-center" data-id="element-87">
          <p className="text-ink/70 mb-8 text-[17px] md:text-lg" data-id="element-88">
            ¿Lista para sentirte mejor?
          </p>
          <CTAButton data-id="element-89">Empezar ahora con MOVÉ SUAVE™ →</CTAButton>
          <p className="text-xs text-ink/60 mt-6" data-id="element-90">
            Acceso inmediato · Pago único · Garantía 60 días
          </p>
        </div>
      </div>
    </section>;
}